module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_aqua_black-b9c9dd4df435ee48a1df6b1d524d193b.svg";